import Chip from "@mui/material/Chip"
import Typography from "@mui/material/Typography"

import Row from "../../../../../common/components/Row"

export function resolvePerformerName(event) {
  return event?.performed_by_name || null
}

export function performedBySubtitle(event) {
  const name = resolvePerformerName(event)
  if (!name) {
    return null
  }
  return `By ${name}`
}

export function PerformedBySubtitle({ event, prefix = "By" }) {
  const name = resolvePerformerName(event)
  if (!name) {
    return null
  }

  return (
    <Row sx={{ alignItems: "center", gap: 0.75 }}>
      <Typography
        variant="body2"
        sx={{ fontSize: "12px" }}
        color="text.secondary"
      >
        {prefix} {name}
      </Typography>
      {event?.performed_by_badge ? (
        <Chip
          label={event.performed_by_badge}
          size="small"
          color="secondary"
          sx={{ height: 20, fontSize: "0.65rem" }}
        />
      ) : null}
    </Row>
  )
}

export function outgoingSmsPerformerName(transaction) {
  return resolvePerformerName(transaction)
}
